module.exports = __webpack_public_path__ + "img/logotype.14291379.png";